import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  en: {
    nav_browse: "Browse", nav_post: "Post a Listing", nav_dashboard: "Dashboard",
    nav_home: "Home",
    nav_signin: "Sign in", nav_logout: "Log out", nav_favorites: "Favorites", nav_profile: "Profile",
    hero_title: "Cameroon's Premier Asset Marketplace",
    hero_sub: "Land, houses, cars, rentals, leases & container structures — curated, verified, and ready for you.",
    search_placeholder: "Search by location, title, or keyword...",
    search_btn: "Search", all: "All",
    featured: "Featured Listings", featured_sub: "Hand-picked premium assets across Cameroon",
    browse_all: "Browse all", explore_cat: "Explore by Category",
    cta_title: "Have something to sell or rent?",
    cta_sub: "List your asset and reach thousands of verified buyers across Cameroon.",
    cta_btn: "Post your listing",
    entice1: "Cameroon's most trusted address for land, homes, vehicles and modular spaces — every listing verified before it goes live.",
    entice2: "From a titled plot in Buea to a furnished apartment in Douala, the right opportunity is just a search away.",
    entice3: "Connect directly with owners and agents by WhatsApp, call or email — no middlemen, no hidden fees, just genuine deals.",
    filters: "Filters", category: "Category", region: "Region", type: "Type",
    price_range: "Price Range (FCFA)", min: "Min", max: "Max", sort: "Sort",
    sort_recent: "Most recent", sort_low: "Price: Low to High", sort_high: "Price: High to Low",
    results: "results", no_results: "No listings found. Try adjusting your filters.",
    contact_seller: "Contact Seller", whatsapp: "WhatsApp", call: "Call", email: "Email",
    description: "Description", details: "Details", location: "Location", views: "views",
    similar: "Similar Listings", apply: "Apply", reset: "Reset",
    post_title: "Post a New Listing", step: "Step",
    step_details: "Asset Details", step_media: "Photos", step_payment: "Payment",
    f_title: "Listing Title", f_category: "Category", f_type: "Listing Type",
    f_price: "Price (FCFA)", f_city: "City / Neighborhood", f_region: "Region",
    f_desc: "Description", f_images: "Image URLs (one per line)",
    upload_device: "Upload from device", uploading: "Uploading...",
    or_url: "or paste an image URL", add: "Add", photo_label: "Label (optional)",
    photos: "photos", cover: "Cover", upload_hint: "Add up to 25 photos. The first photo is the cover.",
    upload_video: "Upload a video (optional)", video_hint: "Max 2 minutes", uploading_video: "Uploading video...",
    video_too_long: "Video is too long. Maximum 2 minutes.", video_title: "Video tour", remove: "Remove",
    fill_required: "Please complete these fields",
    gps_advice: "Optional — but listings with a map location attract far more serious buyers.",
    confirmation_code: "Confirmation code",
    code_note: "Keep this code. Koila Holdings will match it with you to confirm your payment before publishing.",
    view_map_full: "Open in Google Maps",
    f_contact_name: "Contact Name", f_phone: "Phone Number", f_whatsapp: "WhatsApp Number",
    f_first_name: "First Name", f_last_name: "Last Name", f_seller_type: "I am listing as",
    seller_agent: "Agent", seller_landlord: "Landlord / Owner", seller_label: "Listed by",
    f_agent_type: "Agent type", agent_individual: "Individual", agent_institution: "Institution",
    f_institution_type: "Institution type", f_institution_name: "Institution name", f_contact_person: "Contact person",
    inst_bank: "Bank", inst_credit_union: "Credit Union", inst_church: "Church", inst_non_profit: "Non-profit", inst_other: "Other",
    f_email: "Email", next: "Continue", back: "Back",
    loc_section: "Property Location", loc_note: "Required for land & houses",
    specs_section: "Property details",
    f_land_size: "Land / lot size (m²)", f_construction: "Construction status",
    constructed: "Constructed", under_construction: "Under construction",
    f_living_space: "Living space (sq ft) — optional", f_bathrooms: "Bathrooms / toilets",
    f_bath_location: "Toilet location", inside: "Inside", outside: "Outside",
    f_land_title: "Land title available", f_car_title: "Car title (registration) available",
    f_container_size: "Container size (feet)",
    f_car_make: "Make / brand", f_car_model: "Model", f_year: "Year manufactured",
    f_fuel: "Fuel type", f_fuel_desc: "Fuel details (optional)", f_mileage: "Present mileage",
    fuel_diesel: "Diesel", fuel_petrol: "Petrol", fuel_electric: "Electric", fuel_other: "Other",
    amenities_title: "Amenities & utilities",
    f_street: "Street name / Nearby landmark", f_town: "Town / Village",
    f_division: "Division", f_subdivision: "Sub-division",
    f_gps: "GPS Coordinates (optional)", use_gps: "Use my current location",
    gps_captured: "Location captured", view_map: "View on map", location: "Location",
    pay_title: "Activate your listing", pay_desc: "A one-time listing fee makes your asset go live.",
    pay_phone: "MTN MoMo Phone Number", pay_btn: "Pay with MTN MoMo", paying: "Processing payment...",
    pay_success: "Payment successful! Your listing is now live.",
    my_listings: "My Listings", saved: "Saved Favorites", profile_settings: "Profile",
    status_active: "Active", status_pending: "Pending Payment", complete_payment: "Complete Payment",
    delete: "Delete", view: "View", edit_profile: "Save Profile",
    welcome: "Welcome", login_title: "Welcome to Koila Holdings", login_sub: "Sign in to post listings, save favorites and manage your assets.",
    login_google: "Continue with Google", required: "This field is required",
    posted_pending: "Listing created. Complete payment to publish.",
    save_login: "Sign in to save favorites",
    notifications: "Notifications", no_notifications: "No notifications yet", mark_all_read: "Mark all read",
    renew: "Renew", expires: "Expires", expired: "Expired", days_left: "days left",
  },
  fr: {
    nav_browse: "Explorer", nav_post: "Publier une annonce", nav_dashboard: "Tableau de bord",
    nav_home: "Accueil",
    nav_signin: "Se connecter", nav_logout: "Déconnexion", nav_favorites: "Favoris", nav_profile: "Profil",
    hero_title: "La Marketplace d'Actifs N°1 au Cameroun",
    hero_sub: "Terrains, maisons, voitures, locations, baux et conteneurs — sélectionnés, vérifiés et prêts pour vous.",
    search_placeholder: "Rechercher par lieu, titre ou mot-clé...",
    search_btn: "Rechercher", all: "Tous",
    featured: "Annonces en Vedette", featured_sub: "Des actifs premium sélectionnés à travers le Cameroun",
    browse_all: "Voir tout", explore_cat: "Explorer par Catégorie",
    cta_title: "Quelque chose à vendre ou à louer ?",
    cta_sub: "Publiez votre actif et touchez des milliers d'acheteurs vérifiés au Cameroun.",
    cta_btn: "Publier votre annonce",
    entice1: "L'adresse la plus fiable du Cameroun pour terrains, maisons, véhicules et espaces modulaires — chaque annonce est vérifiée avant publication.",
    entice2: "D'un terrain titré à Buea à un appartement meublé à Douala, la bonne opportunité n'est qu'à une recherche.",
    entice3: "Contactez directement propriétaires et agents par WhatsApp, appel ou e-mail — sans intermédiaires ni frais cachés, uniquement de vraies affaires.",
    filters: "Filtres", category: "Catégorie", region: "Région", type: "Type",
    price_range: "Fourchette de Prix (FCFA)", min: "Min", max: "Max", sort: "Trier",
    sort_recent: "Plus récent", sort_low: "Prix : croissant", sort_high: "Prix : décroissant",
    results: "résultats", no_results: "Aucune annonce trouvée. Ajustez vos filtres.",
    contact_seller: "Contacter le Vendeur", whatsapp: "WhatsApp", call: "Appeler", email: "Email",
    description: "Description", details: "Détails", location: "Localisation", views: "vues",
    similar: "Annonces Similaires", apply: "Appliquer", reset: "Réinitialiser",
    post_title: "Publier une Nouvelle Annonce", step: "Étape",
    step_details: "Détails de l'Actif", step_media: "Photos", step_payment: "Paiement",
    f_title: "Titre de l'annonce", f_category: "Catégorie", f_type: "Type d'annonce",
    f_price: "Prix (FCFA)", f_city: "Ville / Quartier", f_region: "Région",
    f_desc: "Description", f_images: "URLs des images (une par ligne)",
    upload_device: "Importer depuis l'appareil", uploading: "Téléchargement...",
    or_url: "ou collez une URL d'image", add: "Ajouter", photo_label: "Légende (optionnel)",
    photos: "photos", cover: "Couverture", upload_hint: "Ajoutez jusqu'à 25 photos. La première est la couverture.",
    upload_video: "Importer une vidéo (optionnel)", video_hint: "2 minutes maximum", uploading_video: "Téléchargement de la vidéo...",
    video_too_long: "La vidéo est trop longue. 2 minutes maximum.", video_title: "Visite vidéo", remove: "Retirer",
    fill_required: "Veuillez remplir ces champs",
    gps_advice: "Optionnel — mais les annonces géolocalisées attirent beaucoup plus d'acheteurs sérieux.",
    confirmation_code: "Code de confirmation",
    code_note: "Conservez ce code. Koila Holdings le vérifiera avec vous pour confirmer votre paiement avant publication.",
    view_map_full: "Ouvrir dans Google Maps",
    f_contact_name: "Nom du contact", f_phone: "Numéro de téléphone", f_whatsapp: "Numéro WhatsApp",
    f_first_name: "Prénom", f_last_name: "Nom", f_seller_type: "Je publie en tant que",
    seller_agent: "Agent", seller_landlord: "Propriétaire / Bailleur", seller_label: "Publié par",
    f_agent_type: "Type d'agent", agent_individual: "Individuel", agent_institution: "Institution",
    f_institution_type: "Type d'institution", f_institution_name: "Nom de l'institution", f_contact_person: "Personne à contacter",
    inst_bank: "Banque", inst_credit_union: "Coopérative de crédit", inst_church: "Église", inst_non_profit: "Association à but non lucratif", inst_other: "Autre",
    f_email: "Email", next: "Continuer", back: "Retour",
    loc_section: "Localisation du bien", loc_note: "Requis pour terrains et maisons",
    specs_section: "Détails du bien",
    f_land_size: "Superficie du terrain (m²)", f_construction: "État de construction",
    constructed: "Construit", under_construction: "En construction",
    f_living_space: "Surface habitable (pi²) — optionnel", f_bathrooms: "Salles de bain / WC",
    f_bath_location: "Emplacement des WC", inside: "Intérieur", outside: "Extérieur",
    f_land_title: "Titre foncier disponible", f_car_title: "Carte grise disponible",
    f_container_size: "Taille du conteneur (pieds)",
    f_car_make: "Marque", f_car_model: "Modèle", f_year: "Année de fabrication",
    f_fuel: "Type de carburant", f_fuel_desc: "Détails carburant (optionnel)", f_mileage: "Kilométrage actuel",
    fuel_diesel: "Diesel", fuel_petrol: "Essence", fuel_electric: "Électrique", fuel_other: "Autre",
    amenities_title: "Commodités & réseaux",
    f_street: "Nom de rue / Repère proche", f_town: "Ville / Village",
    f_division: "Département", f_subdivision: "Arrondissement",
    f_gps: "Coordonnées GPS (optionnel)", use_gps: "Utiliser ma position actuelle",
    gps_captured: "Position enregistrée", view_map: "Voir sur la carte", location: "Localisation",
    pay_title: "Activez votre annonce", pay_desc: "Des frais uniques rendent votre actif visible.",
    pay_phone: "Numéro MTN MoMo", pay_btn: "Payer avec MTN MoMo", paying: "Paiement en cours...",
    pay_success: "Paiement réussi ! Votre annonce est en ligne.",
    my_listings: "Mes Annonces", saved: "Favoris Enregistrés", profile_settings: "Profil",
    status_active: "Active", status_pending: "Paiement en attente", complete_payment: "Finaliser le paiement",
    delete: "Supprimer", view: "Voir", edit_profile: "Enregistrer le Profil",
    welcome: "Bienvenue", login_title: "Bienvenue sur Koila Holdings", login_sub: "Connectez-vous pour publier, enregistrer des favoris et gérer vos actifs.",
    login_google: "Continuer avec Google", required: "Ce champ est requis",
    posted_pending: "Annonce créée. Finalisez le paiement pour publier.",
    save_login: "Connectez-vous pour enregistrer",
    notifications: "Notifications", no_notifications: "Aucune notification", mark_all_read: "Tout marquer comme lu",
    renew: "Renouveler", expires: "Expire le", expired: "Expirée", days_left: "jours restants",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const toggle = useCallback(() => {
    setLang((p) => {
      const next = p === "en" ? "fr" : "en";
      localStorage.setItem("lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => translations[lang][key] || key, [lang]);
  return <LangContext.Provider value={{ lang, t, toggle, setLang }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
